import { Signal } from '@preact/signals-react'

export type SignalOrValue<T> = T | Signal<T>

export function isSignal<T>(value: unknown): value is Signal<T> {
    if (value === null || value === undefined || typeof value !== 'object') {
        return false
    }
    return 'value' in value && typeof (value as Signal<T>).value !== 'undefined'
}

export function unwrapValue<T>(value: SignalOrValue<T> | undefined | null): T | undefined | null {
    if (value === undefined || value === null) {
        return value
    }
    return isSignal(value) ? value.value : (value as T)
}
